import type { OrgConfig, Channel, Member, Mission, ArsenalItem, Badge, ChatMessage, LeaderboardEntry, MissionSubmission } from '../types'

export const mockOrgs: Record<string, OrgConfig> = {
  'diogo-deputado': {
    slug: 'diogo-deputado',
    appName: 'Diogo Deputado',
    logoUrl: '',
    colorPrimary: '#5865F2',
    colorPrimaryHover: '#4752C4',
    welcomeMessage: 'Bem-vindo ao time do Diogo! Juntos somos mais fortes.',
  },
  'sispoli-admin': {
    slug: 'sispoli-admin',
    appName: 'SisPoli Admin',
    logoUrl: '',
    colorPrimary: '#3BA55C',
    colorPrimaryHover: '#2D8049',
    welcomeMessage: 'Bem-vindo ao time SisPoli!',
  },
}

export function getOrgBySlug(slug: string): OrgConfig {
  return mockOrgs[slug] || {
    slug,
    appName: slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    logoUrl: '',
    colorPrimary: '#5865F2',
    colorPrimaryHover: '#4752C4',
    welcomeMessage: 'Bem-vindo! Juntos somos mais fortes.',
  }
}

// Default para componentes que usam mockOrg diretamente
export const mockOrg: OrgConfig = mockOrgs['diogo-deputado']

export const mockChannels: Channel[] = [
  { id: 1, name: 'missões', slug: 'missoes', type: 'missions', icon: 'Target' },
  { id: 4, name: 'contatos', slug: 'contatos', type: 'contacts', icon: 'Users' },
  { id: 5, name: 'blog', slug: 'blog', type: 'chat', icon: 'Newspaper' },
  { id: 2, name: 'materiais', slug: 'materiais', type: 'arsenal', icon: 'FolderDown' },
  { id: 3, name: 'resultados', slug: 'resultados', type: 'results', icon: 'Trophy' },
]

// Canais de discussão por tema (sidebar) — cadastrados na plataforma
export const mockTopicChannels = [
  { id: 10, name: 'Geral', slug: 'geral', color: '#5865F2', unreadCount: 5 },
  { id: 11, name: 'Saúde', slug: 'saude', color: '#23A559', unreadCount: 0 },
  { id: 12, name: 'Educação', slug: 'educacao', color: '#F0B232', unreadCount: 3 },
  { id: 13, name: 'Segurança', slug: 'seguranca', color: '#ED4245', unreadCount: 0 },
  { id: 14, name: 'Emprego', slug: 'emprego', color: '#E67E22', unreadCount: 1 },
  { id: 15, name: 'Transporte', slug: 'transporte', color: '#0BA5EC', unreadCount: 0 },
  { id: 16, name: 'Moradia', slug: 'moradia', color: '#3BA55C', unreadCount: 0 },
  { id: 17, name: 'Cultura', slug: 'cultura', color: '#F47FFF', unreadCount: 2 },
]

export const mockCurrentUser: Member = {
  id: 1,
  name: 'Diogo Nemesio',
  rank: 'prata',
  xp: 1450,
  level: 2,
  isOnline: true,
  missionsCompleted: 28,
  totalPoints: 1450,
  streakDays: 7,
}

export const mockMembers: Member[] = [
  { id: 1, name: 'Diogo Nemesio', rank: 'prata', xp: 1450, level: 2, isOnline: true, missionsCompleted: 28, totalPoints: 1450, streakDays: 7 },
  { id: 2, name: 'Ana Silva', rank: 'prata', xp: 980, level: 2, isOnline: true, missionsCompleted: 19, totalPoints: 980, streakDays: 3 },
  { id: 3, name: 'Carlos Oliveira', rank: 'ouro', xp: 8900, level: 3, isOnline: true, missionsCompleted: 142, totalPoints: 8900, streakDays: 30 },
  { id: 4, name: 'Maria Santos', rank: 'bronze', xp: 320, level: 1, isOnline: false, missionsCompleted: 8, totalPoints: 320, streakDays: 0 },
  { id: 5, name: 'Pedro Costa', rank: 'ouro', xp: 15600, level: 3, isOnline: true, missionsCompleted: 310, totalPoints: 15600, streakDays: 45 },
  { id: 6, name: 'Julia Ferreira', rank: 'ouro', xp: 3200, level: 3, isOnline: false, missionsCompleted: 52, totalPoints: 3200, streakDays: 0 },
  { id: 7, name: 'Lucas Mendes', rank: 'bronze', xp: 80, level: 1, isOnline: true, missionsCompleted: 2, totalPoints: 80, streakDays: 2 },
  { id: 8, name: 'Beatriz Lima', rank: 'ouro', xp: 6100, level: 3, isOnline: false, missionsCompleted: 98, totalPoints: 6100, streakDays: 0 },
  { id: 9, name: 'Rafael Almeida', rank: 'prata', xp: 720, level: 2, isOnline: true, missionsCompleted: 15, totalPoints: 720, streakDays: 5 },
  { id: 10, name: 'Camila Rocha', rank: 'bronze', xp: 420, level: 1, isOnline: true, missionsCompleted: 10, totalPoints: 420, streakDays: 1 },
]

export const mockMissions: Mission[] = [
  // --- DIGITAIS ---
  {
    id: 1,
    title: 'Compartilhar corte sobre educação',
    description: 'Poste o corte do vídeo sobre educação nas redes sociais. Use as hashtags sugeridas e marque o perfil oficial.',
    contentText: 'A educação é a base de tudo! Nosso candidato tem o melhor plano para as escolas da cidade. 📚\n\n✅ Mais creches\n✅ Escola em tempo integral\n✅ Merenda de qualidade\n\nCompartilhe e ajude a espalhar! 💪\n\n#Educação #VotoConsciente #MudançaReal',
    category: 'digital',
    targetPlatforms: ['instagram', 'tiktok', 'kwai'],
    pointsPerPlatform: 20,
    points: 60,
    bonusPoints: 20,
    deadline: '2026-04-17T23:59:00',
    status: 'active',
    submissionsCount: 12,
    createdBy: 'Admin',
    createdAt: '2026-04-15T08:00:00',
  },
  {
    id: 2,
    title: 'Repostar vídeo de saúde pública',
    description: 'Crie um dueto ou reposte o vídeo oficial. Quanto mais criativo, mais bônus!',
    contentText: 'Saúde de qualidade pra todos! 🏥\n\nConheça as propostas:\n🔹 UPA 24h em todos os bairros\n🔹 Mais médicos no SUS\n🔹 Farmácia popular ampliada\n\n#SaúdeParaTodos #VotoConsciente',
    category: 'digital',
    targetPlatforms: ['tiktok', 'kwai', 'instagram'],
    pointsPerPlatform: 25,
    points: 75,
    bonusPoints: 40,
    deadline: '2026-04-18T18:00:00',
    status: 'active',
    submissionsCount: 5,
    createdBy: 'Admin',
    createdAt: '2026-04-15T10:00:00',
  },
  // --- PRESENCIAIS ---
  {
    id: 3,
    title: 'Adesivo no carro',
    description: 'Cole o adesivo oficial no vidro traseiro do seu carro e tire uma foto mostrando o adesivo colado.',
    category: 'presencial',
    targetPlatforms: [],
    pointsPerPlatform: 0,
    points: 100,
    deadline: '2026-04-22T23:59:00',
    status: 'active',
    submissionsCount: 34,
    createdBy: 'Admin',
    createdAt: '2026-04-14T08:00:00',
  },
  {
    id: 4,
    title: 'Adesivo na fachada',
    description: 'Cole o adesivo ou placa na frente da sua casa, comércio ou apartamento. Tire uma foto e envie.',
    category: 'presencial',
    targetPlatforms: [],
    pointsPerPlatform: 0,
    points: 80,
    deadline: '2026-04-22T23:59:00',
    status: 'active',
    submissionsCount: 18,
    createdBy: 'Admin',
    createdAt: '2026-04-14T08:00:00',
  },
  {
    id: 5,
    title: 'Participar do comício',
    description: 'Compareça ao comício no dia 18/04 na Praça Central. Tire uma foto no evento e envie como prova de presença.',
    category: 'presencial',
    targetPlatforms: [],
    pointsPerPlatform: 0,
    points: 150,
    bonusPoints: 50,
    deadline: '2026-04-18T22:00:00',
    status: 'active',
    submissionsCount: 0,
    createdBy: 'Admin',
    createdAt: '2026-04-15T12:00:00',
  },
  {
    id: 6,
    title: 'Visita porta a porta',
    description: 'Faça visitas porta a porta no seu bairro. Converse com pelo menos 10 pessoas e tire fotos das conversas (com permissão).',
    category: 'presencial',
    targetPlatforms: [],
    pointsPerPlatform: 0,
    points: 200,
    deadline: '2026-04-20T18:00:00',
    status: 'active',
    submissionsCount: 8,
    createdBy: 'Admin',
    createdAt: '2026-04-14T10:00:00',
  },
  // --- DIGITAIS (mais) ---
  {
    id: 7,
    title: 'Divulgar nos stories e reels',
    description: 'Compartilhe nos stories e reels. Adicione sua opinião pessoal sobre segurança pública.',
    contentText: 'Segurança com inteligência! 🛡️\n\nChega de violência, precisamos de soluções reais.\n\n#SegurançaPública #MudançaReal',
    category: 'digital',
    targetPlatforms: ['instagram', 'tiktok'],
    pointsPerPlatform: 15,
    points: 30,
    deadline: '2026-04-16T20:00:00',
    status: 'active',
    submissionsCount: 22,
    createdBy: 'Admin',
    createdAt: '2026-04-14T14:00:00',
  },
  {
    id: 8,
    title: 'Campanha de emprego e renda',
    description: 'Compartilhe a arte oficial sobre emprego e renda em todas as plataformas.',
    contentText: 'Mais emprego e renda pra nossa cidade! 💼\n\n📈 Incentivo a microempresas\n📈 Capacitação profissional gratuita\n📈 Feiras de emprego mensais\n\n#Emprego #RendaParaTodos',
    category: 'digital',
    targetPlatforms: ['instagram', 'tiktok', 'kwai'],
    pointsPerPlatform: 20,
    points: 60,
    deadline: '2026-04-14T23:59:00',
    status: 'completed',
    submissionsCount: 45,
    createdBy: 'Admin',
    createdAt: '2026-04-13T09:00:00',
  },
]

export const mockSubmissions: MissionSubmission[] = [
  { id: 1, missionId: 1, userName: 'Ana Silva', postUrl: 'https://instagram.com/p/abc123', platform: 'instagram', status: 'approved', pointsEarned: 50, createdAt: '2026-04-15T09:30:00' },
  { id: 2, missionId: 1, userName: 'Carlos Oliveira', postUrl: 'https://instagram.com/p/def456', platform: 'instagram', status: 'approved', pointsEarned: 70, createdAt: '2026-04-15T10:15:00' },
  { id: 3, missionId: 1, userName: 'Lucas Mendes', postUrl: 'https://instagram.com/p/ghi789', platform: 'instagram', status: 'pending', pointsEarned: 0, createdAt: '2026-04-15T11:00:00' },
]

export const mockArsenal: ArsenalItem[] = [
  { id: 1, title: 'Corte - Educação', description: 'Vídeo corte de 30s sobre o plano de educação', type: 'video', mediaUrl: '', captionText: 'A educação transforma! #VotoConsciente', targetPlatform: 'instagram', downloadCount: 89 },
  { id: 2, title: 'Arte - Saúde Pública', description: 'Card para feed sobre propostas de saúde', type: 'image', mediaUrl: '', captionText: 'Saúde de qualidade para todos!', targetPlatform: 'instagram', downloadCount: 134 },
  { id: 3, title: 'Meme - Debate', description: 'Meme sobre a performance no debate', type: 'meme', mediaUrl: '', captionText: 'Quando o candidato manda a real no debate', targetPlatform: 'any', downloadCount: 256 },
  { id: 4, title: 'Texto - WhatsApp', description: 'Mensagem pronta para grupos de WhatsApp', type: 'text', mediaUrl: '', captionText: 'Fala pessoal! Vcs viram o que o candidato falou sobre...', targetPlatform: 'whatsapp', downloadCount: 67 },
  { id: 5, title: 'Video - Depoimento', description: 'Depoimento de apoiador para stories', type: 'video', mediaUrl: '', captionText: 'Eu apoio porque acredito na mudanca!', targetPlatform: 'tiktok', downloadCount: 45 },
  { id: 6, title: 'Arte - Segurança', description: 'Infográfico sobre plano de segurança', type: 'image', mediaUrl: '', captionText: 'Segurança com inteligência', targetPlatform: 'twitter', downloadCount: 78 },
]

export const mockBadges: Badge[] = [
  { id: 1, code: 'first_mission', name: 'Primeira Missão', description: 'Completou sua primeira missão', icon: 'Rocket', color: '#5865F2', earned: true, earnedAt: '2026-03-01' },
  { id: 2, code: 'streak_7', name: 'Constância 7', description: '7 dias seguidos ativo', icon: 'Flame', color: '#F0B232', earned: true, earnedAt: '2026-04-10' },
  { id: 3, code: 'veteran', name: 'Veterano', description: 'Completou 50 missões', icon: 'Medal', color: '#FAA61A', earned: false },
  { id: 4, code: 'viral', name: 'Viral', description: 'Post com mais engajamento da semana', icon: 'Zap', color: '#ED4245', earned: false },
  { id: 5, code: 'recruiter', name: 'Recrutador', description: 'Convidou 5 membros', icon: 'Users', color: '#3BA55C', earned: true, earnedAt: '2026-03-20' },
  { id: 6, code: 'streak_30', name: 'Constância 30', description: '30 dias seguidos ativo', icon: 'Crown', color: '#F47FFF', earned: false },
  { id: 7, code: 'arsenal_master', name: 'Artilheiro', description: 'Usou 20 itens do arsenal', icon: 'Crosshair', color: '#0BA5EC', earned: true, earnedAt: '2026-04-05' },
]

export const mockMessages: ChatMessage[] = [
  { id: 1, userId: 3, userName: 'Carlos Oliveira', userRank: 'ouro', content: 'Bom dia pessoal! Vamos com tudo hoje nas missões!', createdAt: '2026-04-15T08:00:00' },
  { id: 2, userId: 2, userName: 'Ana Silva', userRank: 'prata', content: 'Já postei o corte de educação, ficou top!', createdAt: '2026-04-15T08:15:00' },
  { id: 3, userId: 5, userName: 'Pedro Costa', userRank: 'ouro', content: 'Excelente Ana! O importante é manter a constância. Quem tá na streak de 7 dias?', createdAt: '2026-04-15T08:20:00' },
  { id: 4, userId: 7, userName: 'Lucas Mendes', userRank: 'bronze', content: 'Comecei ontem, to no dia 2! Bora que bora', createdAt: '2026-04-15T08:25:00' },
  { id: 5, userId: 1, userName: 'Diogo Nemesio', userRank: 'prata', content: 'Lucas, manda ver! Qualquer dúvida a gente ajuda aqui.', createdAt: '2026-04-15T08:30:00' },
  { id: 6, userId: 9, userName: 'Rafael Almeida', userRank: 'prata', content: 'Alguém tem o link do corte novo sobre saúde? Não encontrei no arsenal.', createdAt: '2026-04-15T09:00:00' },
  { id: 7, userId: 3, userName: 'Carlos Oliveira', userRank: 'ouro', content: 'Rafael, tá na missão 1! Abre lá que tem o conteúdo e a legenda pronta.', createdAt: '2026-04-15T09:05:00' },
  { id: 8, userId: 10, userName: 'Camila Rocha', userRank: 'bronze', content: 'Gente, meu post do TikTok já tá com 2k views! 🔥', createdAt: '2026-04-15T09:30:00' },
  { id: 9, userId: 10, userName: 'Camila Rocha', userRank: 'bronze', content: '', media: { type: 'image', name: 'print-tiktok.jpg', size: '245 KB', url: '' }, createdAt: '2026-04-15T09:30:30' },
  { id: 10, userId: 5, userName: 'Pedro Costa', userRank: 'ouro', content: 'Isso aí Camila! Potencial de viral. Manda o link pra gente ir lá curtir e comentar.', createdAt: '2026-04-15T09:32:00' },
  { id: 11, userId: 3, userName: 'Carlos Oliveira', userRank: 'ouro', content: 'Pessoal, segue o cronograma da semana:', media: { type: 'document', name: 'cronograma-semana-16.pdf', size: '120 KB', url: '' }, createdAt: '2026-04-15T09:40:00' },
  { id: 12, userId: 10, userName: 'Camila Rocha', userRank: 'bronze', content: 'Acabei de submeter na missão 2! O bônus é nosso 💪', createdAt: '2026-04-15T09:45:00' },
]

export const mockLeaderboard: LeaderboardEntry[] = mockMembers
  .sort((a, b) => b.totalPoints - a.totalPoints)
  .map((member, i) => ({
    position: i + 1,
    member,
    weeklyXp: Math.floor(Math.random() * 500) + 50,
  }))

export const RANK_CONFIG: Record<string, { label: string; minXp: number; color: string }> = {
  bronze: { label: 'Bronze', minXp: 0,    color: '#CD7F32' },
  prata:  { label: 'Prata',  minXp: 500,  color: '#A0AEC0' },
  ouro:   { label: 'Ouro',   minXp: 2000, color: '#F59E0B' },
}

export const PLATFORM_CONFIG: Record<string, { label: string; color: string; icon: string }> = {
  instagram: { label: 'Instagram', color: '#E1306C', icon: 'Instagram' },
  tiktok:    { label: 'TikTok',    color: '#010101', icon: 'Music' },
  kwai:      { label: 'Kwai',      color: '#FF6600', icon: 'Clapperboard' },
  twitter:   { label: 'Twitter/X', color: '#1DA1F2', icon: 'Twitter' },
  youtube:   { label: 'YouTube',   color: '#FF0000', icon: 'Youtube' },
  whatsapp:  { label: 'WhatsApp',  color: '#25D366', icon: 'MessageCircle' },
  facebook:  { label: 'Facebook',  color: '#1877F2', icon: 'Facebook' },
  any:       { label: 'Qualquer',  color: '#949BA4', icon: 'Globe' },
}
